import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'
import { useEffect, useState } from 'react'

const radioStyle = {
    paddingBottom: 0,
    display: 'none',
  }
  
  const radioOverrideMuiStyle = {
    '&.MuiRadio-root': {
      '&.Mui-checked + span': {
        backgroundColor: `primary.main`,
        color: '#FFF !important',
      },
    },
  }
  
  const textStyle = {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    display: 'inline-flex',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'primary.main',
    marginTop: 0,
    marginRight: '6px',
    marginBottom: '10px',
    fontWeight: 'bold',
    verticalAlign: 'top',
    width: '100%',
    height: '100%',
    minHeight: 80,
    cursor: 'pointer',
  }

const BrooksonWelcomePage = ({ validate }: FormSectionProps) => {
    const form = useForm();
    const theme = useTheme()
    //@ts-ignore
    const custom = theme?.custom

    return (
        <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 8 }} style={{textAlign: 'center'}}>
            Hey, 👋 I’m {custom.customization.botName || 'Parker'}, my job is to take some information ahead of an adviser appointment
          </Typography>
          <Typography
              component="span"
              sx={{
                ...textStyle,
                margin: 'auto',
                width: '300px',
                backgroundColor: lighten(theme.palette.primary.main, 0.8),
              }}
              onClick={async () => {
                await form.submit()
              }}
            >
              Let's get going
            </Typography>
        </FormWizard.Page>
      </Box>
    )
};

export default BrooksonWelcomePage;